import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'filesize',
  pure: true,
  standalone: false,
})
export class FileSizePipe implements PipeTransform {
  public transform(sizeInBytes: number): string {
    if (sizeInBytes === 0 || isNaN(sizeInBytes)) {
      return '0 KB'
    }

    const kb = 1024
    const mb = kb * 1024

    if (sizeInBytes >= mb) {
      return (sizeInBytes / mb).toFixed(2) + ' MB'
    }

    return (sizeInBytes / kb).toFixed(2) + ' KB'
  }
}
